import axios from "axios";

export const getSection1 = async () => {
  return await axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/api/about-page-s1-about?populate=*`,
    )
    .then((response) => response.data)
    .catch((error) => error);
};
